import { connectCustom } from "@client/lib/misc";
import { makeEntityChildrenIdsSelector } from "@client/selectors";
import { type BaseAppState, type EntityRef } from "@client/types";
import Component from "./component";

const makeMapStateToProps = () => {
  const childrenIdsSelector = makeEntityChildrenIdsSelector();
  return (state: BaseAppState, props: EntityRef) => {
    return {
      childrenIds: childrenIdsSelector(state, props),
      ...props
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
